<template>
  <font-awesome-icon
    icon="file-contract"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFileContract } from '@fortawesome/free-solid-svg-icons'

library.add(faFileContract)

export default {
  name: 'CoozzyFileContractIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
